(function () {
  function openCartDrawer() {
    const drawerComponent = document.querySelector('cart-drawer-component');
    const drawerTrigger =
      document.querySelector('[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('.header-actions__action[aria-haspopup="dialog"]');

    if (drawerComponent && typeof drawerComponent.open === 'function') {
      drawerComponent.open();
      return;
    }

    if (drawerTrigger) {
      drawerTrigger.click();
    }
  }

  async function refreshCartDrawer() {
    const drawerCartItems = document.querySelector('cart-items-component[data-drawer]');
    const sectionId = drawerCartItems?.dataset.sectionId;

    if (!sectionId) return;

    const sectionResponse = await fetch(`/?sections=${sectionId}&_=${Date.now()}`, {
      headers: { Accept: 'application/json' },
    });
    const sectionData = await sectionResponse.json();

    if (!sectionData || !sectionData[sectionId]) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionData[sectionId], 'text/html');

    const newDrawerItems = doc.querySelector(
      `cart-items-component[data-drawer][data-section-id="${sectionId}"]`
    );
    const currentDrawerItems = document.querySelector(
      `cart-items-component[data-drawer][data-section-id="${sectionId}"]`
    );

    if (newDrawerItems && currentDrawerItems) {
      currentDrawerItems.replaceWith(newDrawerItems);
    }
  }

  async function refreshCartBubble() {
    try {
      const cartResponse = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();

      const bubbleCount = document.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"]');
      const bubbleWrapper = document.querySelector('.cart-bubble, [ref="cartBubble"]');

      if (bubbleCount) {
        bubbleCount.textContent = cart.item_count;
        bubbleCount.classList.toggle('hidden', cart.item_count === 0);
      }

      if (bubbleWrapper) {
        bubbleWrapper.classList.toggle('visually-hidden', cart.item_count === 0);
      }
    } catch (err) {
      console.warn('ISL quick add bubble refresh failed', err);
    }
  }

  function initCard(card) {
    if (card.dataset.islCardInit === 'true') return;
    card.dataset.islCardInit = 'true';

    const variantButtons = card.querySelectorAll('[data-isl-variant-btn]');
    const variantInput = card.querySelector('[data-isl-variant-input]');
    const addText = card.querySelector('[data-isl-add-text]');
    const addBtn = card.querySelector('[data-isl-add-btn]');
    const form = card.querySelector('[data-isl-add-form]');

    if (!variantInput || !addText || !addBtn || !form) return;

    function setActive(btn) {
      variantButtons.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const id = btn.getAttribute('data-variant-id');
      const price = btn.getAttribute('data-variant-price');
      const available = btn.getAttribute('data-variant-available') === 'true';

      variantInput.value = id || '';
      addText.textContent = `Ajouter • ${price || ''}`;
      addBtn.disabled = !available;
    }

    variantButtons.forEach((btn) => {
      btn.addEventListener('click', () => setActive(btn));
    });

    const active = card.querySelector('[data-isl-variant-btn].is-active') || variantButtons[0];
    if (active) setActive(active);

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = variantInput.value;
      if (!variantId || addBtn.disabled) return;

      const originalText = addText.textContent;
      addBtn.disabled = true;
      addText.textContent = 'Ajout...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
          }),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          console.warn('ISL quick add error', data);
          addText.textContent = originalText;
          addBtn.disabled = false;
          return;
        }

        openCartDrawer();
        await refreshCartDrawer();
        await refreshCartBubble();

        addText.textContent = originalText;
        addBtn.disabled = false;
      } catch (error) {
        console.error('ISL quick add failed', error);
        addText.textContent = originalText;
        addBtn.disabled = false;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(() => initAll());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();